var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.dialogVisible, width: "30%", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "p1" }, [_vm._v("批量导入")]),
        _c("span", { staticClass: "p2" }, [_vm._v("下载文件模板")]),
      ]),
      _c(
        "el-upload",
        {
          staticClass: "upload-demo",
          staticStyle: { "margin-bottom": "0.3rem" },
          attrs: {
            action: "https://jsonplaceholder.typicode.com/posts/",
            multiple: "",
            limit: 3,
            "file-list": _vm.fileList,
          },
        },
        [
          _c("span", { staticStyle: { "font-size": "0.12rem" } }, [
            _vm._v("点击上传文件"),
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-upload",
            staticStyle: { color: "#000" },
          }),
        ]
      ),
      _c(
        "div",
        [
          _c("el-tag", { attrs: { size: "small", closable: "" } }, [
            _vm._v("小型标签"),
          ]),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("导 入")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }